// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMoveMemberNumberBySurveyQuestionRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentMoveMemberNumberBySurveyQuestionRequestModel.attributeTypeMap;
    }
}
EnrollmentMoveMemberNumberBySurveyQuestionRequestModel.discriminator = undefined;
EnrollmentMoveMemberNumberBySurveyQuestionRequestModel.additionalProperties = false;
EnrollmentMoveMemberNumberBySurveyQuestionRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "TCSSource"
    },
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerKey",
        "baseName": "answerKey",
        "type": "number"
    },
    {
        "name": "answerText",
        "baseName": "answerText",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentMoveMemberNumberBySurveyQuestionRequestModel.js.map